// Razorpay Configuration
type Environment = 'test' | 'live';

// Get environment from environment variables
const env: Environment = (process.env.NEXT_PUBLIC_RAZORPAY_ENV || 'test') as Environment;

// Base URLs for different environments
const API_BASE_URLS = {
  test: 'https://api.razorpay.com/v1',
  live: 'https://api.razorpay.com/v1',
};

// Razorpay configuration
export const razorpayConfig = {
  // API endpoints
  baseUrl: API_BASE_URLS[env],
  createOrderUrl: `${API_BASE_URLS[env]}/orders`,
  
  // Credentials - these should be in your environment variables
  keyId: process.env.RAZORPAY_KEY_ID || '',
  keySecret: process.env.RAZORPAY_KEY_SECRET || '',
  webhookSecret: process.env.RAZORPAY_WEBHOOK_SECRET || '',
  
  // Environment
  isProduction: env === 'live',
  environment: env,
  
  // Default values
  defaultRedirectUrl: process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3001',
  
  // Frontend script URLs
  scriptUrl: 'https://checkout.razorpay.com/v1/checkout.js',
  
  // Currency
  currency: 'INR',
};

// Razorpay order types
export interface RazorpayOrderRequest {
  amount: number; // in paise
  currency: string;
  receipt: string;
  notes?: Record<string, string>;
  partial_payment?: boolean;
}

export interface RazorpayOrderResponse {
  id: string;
  entity: string;
  amount: number;
  amount_paid: number;
  amount_due: number;
  currency: string;
  receipt: string;
  offer_id: string | null;
  status: 'created' | 'attempted' | 'paid';
  attempts: number;
  notes: Record<string, string>;
  created_at: number;
}

export interface RazorpayPaymentRequest {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

export interface RazorpayWebhookPayload {
  entity: string;
  account_id: string;
  event: string;
  contains: string[];
  payload: {
    payment: {
      entity: {
        id: string;
        entity: string;
        amount: number;
        currency: string;
        status: 'created' | 'authorized' | 'captured' | 'failed' | 'refunded';
        order_id: string;
        invoice_id: string | null;
        international: boolean;
        method: string;
        amount_refunded: number;
        refund_status: string | null;
        captured: boolean;
        description: string | null;
        card_id: string | null;
        bank: string | null;
        wallet: string | null;
        vpa: string | null;
        email: string;
        contact: string;
        notes: Record<string, string>;
        fee: number;
        tax: number;
        error_code: string | null;
        error_description: string | null;
        error_source: string | null;
        error_step: string | null;
        error_reason: string | null;
        acquirer_data: Record<string, unknown>;
        created_at: number;
      };
    };
    order: {
      entity: {
        id: string;
        entity: string;
        amount: number;
        amount_paid: number;
        amount_due: number;
        currency: string;
        receipt: string;
        offer_id: string | null;
        status: 'created' | 'attempted' | 'paid';
        attempts: number;
        notes: Record<string, string>;
        created_at: number;
      };
    };
  };
  created_at: number;
}

// Payment status types
export type RazorpayPaymentStatus = 'created' | 'authorized' | 'captured' | 'failed' | 'refunded';

// Payment method types
export type RazorpayPaymentMethod = 'card' | 'netbanking' | 'wallet' | 'upi' | 'cardlessemi';
